var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "damages-confirmed view",
      class: { detailCartConfirmed: _vm.showCartDetail },
    },
    [
      _c(
        "div",
        { staticClass: "view_top" },
        [
          _c("ma-navbar-category", {
            attrs: {
              titleNavbar: _vm.$t("damagesConfirmed.titleDamagesConfirmed"),
              qaName: "go-to-damagesConfirmed-btn",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "view_content" },
        _vm._l(_vm.damagesDetails, function (damageCategory) {
          return _c("ul", { staticClass: "damage-category_list" }, [
            _c("div", { staticClass: "view_content_markdown" }, [
              _c(
                "h3",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showCartDetail,
                      expression: "!showCartDetail",
                    },
                  ],
                  staticClass: "mg mg--b-3",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        damageCategory[0].selfcare_title ||
                          damageCategory[0].selfcare_subtitle
                      )
                  ),
                ]
              ),
            ]),
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: damageCategory[0].surface,
                    expression: "damageCategory[0].surface",
                  },
                ],
                staticClass: "surface-info",
              },
              [
                _c("p", { staticClass: "text-small-bold gray" }, [
                  _vm._v(
                    _vm._s(
                      damageCategory[0].surface
                        ? damageCategory[0].surface.key
                        : null
                    )
                  ),
                ]),
                _c("p", { staticClass: "text-medium gray" }, [
                  _vm._v(
                    _vm._s(
                      damageCategory[0].surface
                        ? damageCategory[0].surface.literal
                        : null
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "listDetails" },
              _vm._l(damageCategory, function (damage) {
                return damage.images.length > 0 || damage.details.length > 0
                  ? _c("li", [
                      _c("div", { staticClass: "damage-card" }, [
                        _c(
                          "p",
                          { staticClass: "headline-medium gray mg mg--b-4" },
                          [
                            _vm._v(
                              _vm._s(_vm.getSubtitle(damage.selfcare_subtitle))
                            ),
                          ]
                        ),
                        _c(
                          "ul",
                          { staticClass: "list-damage-card" },
                          _vm._l(damage.details, function (detail) {
                            return _c("li", { staticClass: "mg mg--b-4" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-small-bold gray mg mg--b-2",
                                },
                                [_vm._v(_vm._s(detail.key))]
                              ),
                              _c("p", { staticClass: "text-medium gray" }, [
                                _vm._v(_vm._s(detail.literal)),
                              ]),
                            ])
                          }),
                          0
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.getImageSrc(
                                    "inputImgEnsemble",
                                    damage.images
                                  ).length >= 1,
                                expression:
                                  'getImageSrc("inputImgEnsemble", damage.images).length >=1',
                              },
                            ],
                            staticClass: "list-img-ensemble",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "text-small-bold gray mg mg--b-2",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("damagesConfirmed.photosEnsemble")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "ul",
                              { staticClass: "images-list_container" },
                              _vm._l(
                                _vm.getImageSrc(
                                  "inputImgEnsemble",
                                  damage.images
                                ),
                                function (image) {
                                  return _c("li", [
                                    _c("img", { attrs: { src: image } }),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.getImageSrc("inputImgPres", damage.images)
                                    .length >= 1,
                                expression:
                                  'getImageSrc("inputImgPres", damage.images).length >=1',
                              },
                            ],
                            staticClass: "list-img-pres",
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "text-small-bold gray mg mg--b-2",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("damagesConfirmed.photosPres"))
                                ),
                              ]
                            ),
                            _c(
                              "ul",
                              {
                                staticClass: "images-list_container mg mg--t-4",
                              },
                              _vm._l(
                                _vm.getImageSrc("inputImgPres", damage.images),
                                function (image) {
                                  return _c("li", [
                                    _c("img", { attrs: { src: image } }),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ])
                  : damage.images.length === 0 && damage.details.length === 0
                  ? _c(
                      "div",
                      { staticClass: "container-message gray mg mg--t-3" },
                      [
                        _c(
                          "p",
                          { staticClass: "headline-medium gray mg mg--b-3" },
                          [
                            _vm._v(
                              _vm._s(_vm.getSubtitle(damage.selfcare_subtitle))
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "container-icon grid grid--ai-middle grid--jc-middle grid--column mg mg--b-4",
                          },
                          [
                            _c("svgicon", {
                              attrs: {
                                name: "Info",
                                color: "$primary01",
                                height: "48",
                                width: "48",
                              },
                            }),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "text-medium gray mg mg--t-3 mg--l-3 mg--r-3",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("commonDamages.emptyData"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e()
              }),
              0
            ),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _c("buttonBotton", {
            attrs: {
              handleButtonClick: _vm.handleClickAcceptDamages,
              handleButtonClickWhiteBtn: _vm.handleClickReviseDamages,
              title: _vm.$t("actions.confirmDommages"),
              titleWhiteBtn: _vm.$t("actions.addMoreDamage"),
              btnType: "functionalBtnWhite",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }